import { combineReducers } from '@reduxjs/toolkit';
import formViewDialog from './formViewDialogReducer';


const reducer = combineReducers({
	formViewDialog
});

export default reducer;